var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('login-page-template',[_c('recovery-code-form',{attrs:{"username":_vm.username,"password":_vm.password}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }